import React from 'react';
import { connect } from 'react-redux';
import { Alert } from '../../components';
import BoardCard from '../../components/board-card';
import { MenuItem } from '../../components/prime';
import { IDataStorage } from '../../core';
import Translate from '../../core/translate';
import API from '../../services/api';
import Common from '../../services/common';
import HeaderLayoult from '../header';
import MenuLayoult from '../menu';
import styles from './styles.module.scss';

const headerHeigth = '65px';
const widths = {
  min: 42,
  max: 240,
}

interface IProps {
  storage?: IDataStorage;

  children?: any;
  location?: any;
}

interface IState {
  storage?: IDataStorage;

  securityToken?: string;
  menuWidth: number;
  menu?: MenuItem[];
  location?: any;

  boardCard?: {
    tipo: 'CO' | 'OP';
    id: number;
    callback?: (forceRollback?: boolean) => void;
  }
}

class Index extends React.Component<IProps, IState> {
  state : IState = { menuWidth: widths.max };

  constructor(p:IProps) {
    super(p);
    const menuWidth = parseInt(Common.session.get("CNET-BO-MenuState"));
    this.state = {
      menuWidth: isNaN(menuWidth) ? widths.max : menuWidth
    }
  }
  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);    /*UserData.get("MainLayoult").then(data => this.setState({ })).catch(ex => console.log("error", ex));*/
    (window as any).OpenCard = this.OpenCard;
    (window as any).OpenCardByCodigo = this.OpenCardByCodigo;
    (window as any).CloseCard = this.CloseCard;
  }
  static getDerivedStateFromProps = (p: IProps, s: IState) : IState => {
    let res : IState = s ?? { };
    if (p?.location !== s?.location) res.location = p.location;
    if (p?.storage !== s?.storage) res.storage = p.storage;
    return res;
  }

  CloseCard = (forceRefresh?: boolean) => {
    const callback = this.state.boardCard?.callback;
    callback && callback(forceRefresh);
    this.setState({ boardCard: undefined });
  }

  OpenCard = (tipo:'CO' | 'OP', id: number, callback?: (forceRollback?: boolean) => void) => {
    this.setState({ boardCard: { tipo, id, callback } });
  }

  OpenCardByCodigo = (tipo:'CO' | 'OP', codigo: string | number, callback?: (forceRollback?: boolean) => void) => {
    const t = Translate.get("Menu", this.state.storage?.languaje);
    API.entity().card().getId({ tipo, codigo }).then(res => {
      Alert.reponse(res);
      if (res.success && res.data) this.OpenCard(tipo, res.data, callback);
    }).catch(err => Alert.error(t("@Id#ErrorInesperado"), err))
  }

  setMenu = (width: number) => {
    Common.session.set("CNET-BO-MenuState", width);
    this.setState({ menuWidth: width });
  }
  
  render() {
    const { children } = this.props;
    const { menu, menuWidth, boardCard } = this.state;
    const t = Translate.get("Menu", this.state.storage?.languaje);

    return (
      <>

        <BoardCard tipo={boardCard?.tipo} id={boardCard?.id} />
        
        {/* CABECERA */}
        <div className={styles.header} style={{ height: headerHeigth }}>
          <HeaderLayoult menu={menu ?? []} />
        </div>

        {/* BODY */}
        <div className={`row ${styles.body}`} ref={el => (window as any).mainbody = el}>

          {/* MENU IZQUIERDO */}
          <div className={styles["main-menu"]} style={{ height: `calc(100vh - ${headerHeigth})`, width: menuWidth, overflowY: 'auto', overflowX: 'hidden', borderRight: '1px solid var(--background-work-border)' }}>
            <MenuLayoult opened={menuWidth === widths.max} onToogleOpen={() => this.setMenu(menuWidth === widths.max ? widths.min : widths.max)} />
          </div>

          {/* CONTENIDO */}
          <div id="content" className={`col ${styles.content}`} style={{ width: `calc(100vw - ${menuWidth}px)`, height: `calc(100vh - ${headerHeigth})` }}>

            {/* PAGINA ABIERTA */}
            <div id="openpage" className={styles.specificContent} style={{ height: `calc(100vh - ${headerHeigth})` }}>
              <div style={{ width: '100%', height: `calc(100vh - ${headerHeigth} - 27px)`, overflowY: 'auto' }}>
                {children}
              </div>
              <div style={{ height: 27, backgroundColor: 'var(--background)', borderTop: `1px solid var(--background-work-border)`, color: 'var(--color)', fontSize: '0.8rem', textAlign: 'center', paddingTop: '0.25rem', paddingRight: '1rem', userSelect: 'none' }}>
                <div>{t("Copyright", { anio: new Date().getFullYear(), version: (window as any).app_version, enviroment: (window as any).app_enviroment })}</div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
